import AlertDialog from "../../components/atoms/dialog/AlertDialog";
import ConfirmDialog from "../../components/atoms/dialog/ConfirmDialog";
import NicknameDialog from "../../components/atoms/dialog/NicknameDialog";
import EmailDialog from "../../components/atoms/dialog/EmailDialog";
import MarketingAgreementDialog from "../../components/atoms/dialog/MarketingAgreementDialog";
import TournamentNoticeDialog from "../../components/atoms/dialog/TournamentNoticeDialog";
import ReportDialog from "../../components/atoms/dialog/ReportDialog";
import TournamentCancelDialog from "../../components/atoms/dialog/TournamentCancelDialog";
import TournamentQrCodeDialog from "../../components/atoms/dialog/TournamentQrCodeDialog";
import NoticeModal from "../../components/atoms/modal/NoticeModal";
import SelectGolfParkStoreModal from "../../components/atoms/modal/SelectGolfParkStoreModal";
import TermsModal from "../../components/atoms/modal/TermsModal";
import BaseModal from "../../components/atoms/modal/base/BaseModal";

export const modalRegistry = {
    BASE_MODAL: BaseModal,
    SELECT_GOLFPARKS_MODAL: SelectGolfParkStoreModal,
    NOTICE_MODAL: NoticeModal,
    TERMS_MODAL: TermsModal,

    ALERT_DIALOG: AlertDialog,
    CONFIRM_DIALOG: ConfirmDialog,
    NICKNAME_DIALOG: NicknameDialog,
    EMAIL_DIALOG: EmailDialog,
    MARKETING_AGREEMENT_DIALOG: MarketingAgreementDialog,
    TOURNAMENT_NOTICE_DIALOG: TournamentNoticeDialog,
    REPORT_DIALOG: ReportDialog,
    TOURNAMENT_CANCEL_DIALOG: TournamentCancelDialog,
    TOURNAMENT_QR_CODE_DIALOG: TournamentQrCodeDialog
};

export type ModalKey = keyof typeof modalRegistry;
